import { useEffect } from 'react'
import { useAdminInfo } from './useAdminInfo'

export const useGetRandomUser = () => {
    const { adminInfo, getAdminInfo } = useAdminInfo()

    useEffect(() => {
        if (!adminInfo?.firstLetter) { getAdminInfo() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminInfo])

    const getPlatformUser = (firstName: string) => {
        const firstLetter = adminInfo?.firstLetter
        const randomNumber = Math.floor(Math.random() * 100)
        const firstLettrsOfName = firstName?.slice(0, 10)
        return `${firstLetter?.trim() ?? ''}${firstLettrsOfName?.trim()?.toLowerCase()}${randomNumber}`
    }

    return { getPlatformUser }
}
